import { useMemo } from 'react'
import Iframe from 'shared/components/Iframe'
import { useIframe } from 'shared/hooks'
import { Title } from '../Cockpit.styles'

type EmbeddedMasterdataChartProps = {
  props?: {
    uuid_objectclass?: string
    uuid_sitemodel?: string
    uuid_classification?: string
  }
  title?: string
}

const EmbeddedMasterdataChart = ({
  props,
  title
}: EmbeddedMasterdataChartProps) => {
  const iframeSource = useMemo(() => {
    const origin = globalThis.location.origin

    const params = new URLSearchParams()

    const attributes = ['uuid_objectclass', 'uuid_classification']

    attributes.forEach((attribute) => {
      const value = props?.[attribute as keyof typeof props]
      if (value) {
        params.append(attribute, value as string)
      }
    })

    return `${origin}/${props?.uuid_sitemodel || ''}?${params.toString()}`
  }, [props])

  const { iframeAttributes } = useIframe({
    origin,
    src: iframeSource,
    title
  })

  if (!iframeAttributes || !props) {
    return null
  }

  return (
    <>
      {title && <Title>{title}</Title>}
      <Iframe {...iframeAttributes} />
    </>
  )
}

export default EmbeddedMasterdataChart
